import {
  PaginationMeta,
  PublicContract,
} from "./types/publicContractTypes";

export const unwrapResponseData = <T = any>(payload: any): T => {
  if (payload == null) return payload;
  if (
    payload.data !== undefined &&
    (payload.isSuccessful !== undefined || payload.message !== undefined)
  ) {
    return payload.data as T;
  }
  return payload as T;
};

const toMeta = (meta: any, fallbackCount: number): PaginationMeta => ({
  totalItems: Number(meta?.totalItems ?? meta?.total ?? fallbackCount) || 0,
  totalPages: Number(meta?.totalPages ?? meta?.pages ?? 1) || 1,
  itemsPerPage: Number(meta?.itemsPerPage ?? meta?.limit ?? 10) || 10,
  currentPage: Number(meta?.currentPage ?? meta?.page ?? 1) || 1,
});

export const unwrapPaginatedPublicContracts = (payload: any) => {
  const data = unwrapResponseData(payload);

  if (Array.isArray(data)) {
    return {
      items: data as PublicContract[],
      meta: toMeta({}, data.length),
    };
  }

  const nested = data?.data;
  const itemsCandidate =
    data?.items ??
    data?.records ??
    (Array.isArray(nested) ? nested : nested?.items ?? nested?.records);

  const items = (Array.isArray(itemsCandidate) ? itemsCandidate : []) as PublicContract[];
  const meta = data?.meta ?? nested?.meta ?? {};

  return {
    items,
    meta: toMeta(meta, items.length),
  };
};
